export default "__VITE_ASSET__w60nQEy9__"